export default __webpack_public_path__ + "static/media/flujo.72f384a6.png";